import Modernizr from 'modernizr';
import WebFont from "webfontloader";
import ImagesLoaded from "imagesloaded";
import 'slick-carousel';



// ここに処理を書いていく👇
$(() => {

	// Check behavior//*
	console.log($.fn);//OK
	console.log(Modernizr);//OK
	console.log(ImagesLoaded);//OK
	console.log(WebFont.load);//OK
	console.log(process.env.NODE_ENV);

	if($('body').hasClass('home')){
		$(window).scroll(function() {
		var top = $('#main').offset().top;
		var position = 160 - $(window).scrollTop();
			if(position < 0){
				$('header').addClass('active');
				$('#mm').addClass('active');
			}else{
				$('header').removeClass('active');
				$('#mm').removeClass('active');
			}
		});
		var slidehight = slidehight || {};
		slidehight.VIEW_HEIGHT = {
			init : function(){
				this.setParameters();
				this.setKvHeight();
				this.bind();
			},
			setParameters : function(){
				this.$window = $(window);
				this.$target = $('.l-slider-content');
			},
			bind : function(){
				var _self = this;
				this.$window.on('resize',function(){
						_self.setKvHeight();
				});
			},
			setKvHeight : function(){
				this.$target.css('height',this.$window.height());
			}
		};
		$(function(){
			slidehight.VIEW_HEIGHT.init();
		});
	}

	$(".slider-for").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: ".slider-nav"
	});
	$(".slider-nav").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		focusOnSelect: true,
		draggable: false,
		arrows: true,
		dots: true,
		autoplay: true,
		speed: 1000,
		cssEase: 'cubic-bezier(0,1,.6,1)',
		asNavFor: ".slider-for",
		responsive: [{
      breakpoint: 1080,
      settings: {
        draggable: true
      }
    }]
	});

	if(window.matchMedia('screen and (min-width:1000px)').matches){
    var topsize = 48;
  }else{
    topsize = 55;
	}

	$(".sp-menu-toggle").click(function(){
		$(this).toggleClass('active');
		$('.sp-menu').toggleClass('active');
	});
	$("#close").click(function(){
		$(this).parent().removeClass('active');
		$(this).parent().addClass('closed');
	});

  $("a[href^='#']").click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top-topsize;
    $('body,html').animate({scrollTop:position}, 600);
    return false;
	});
});



// WEBPACK FOOTER //
// ./build/assets/js/scripts.js